import { useEffect, useState } from "react";
import { Coins, Receipt, ShieldCheck } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, fmtError } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const entryLabel = (type) => ({
  admin_grant: "Credito concedido pelo administrador",
  omr_reservation: "Reserva de processamento",
  omr_refund: "Estorno automatico",
  purchase: "Compra de creditos",
}[type] || type || "Lancamento");

export default function CreditWalletPage() {
  const [schools, setSchools] = useState([]);
  const [scope, setScope] = useState("personal");
  const [account, setAccount] = useState(null);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/schools").then((response) => {
      const items = response.data || [];
      setSchools(items);
      if (items.length === 1) setScope(items[0].id);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const suffix = scope === "personal" ? "" : `?school_id=${encodeURIComponent(scope)}`;
    api.get(`/credits/me/ledger${suffix}`)
      .then((response) => {
        setAccount(response.data.account);
        setEntries(response.data.entries || []);
      })
      .catch((error) => toast.error(fmtError(error)))
      .finally(() => setLoading(false));
  }, [scope]);

  return (
    <div className="max-w-5xl mx-auto px-8 py-10" data-testid="credit-wallet-page">
      <div className="border-b border-border pb-6 mb-6">
        <div className="label-eyebrow mb-2">cobranca · consumo auditavel</div>
        <h1 className="font-display text-5xl font-black tracking-tighter">Minha carteira.</h1>
        <p className="text-sm text-muted-foreground mt-3">Uma correcao concluida consome um credito por pagina. Falhas anteriores a persistencia sao estornadas.</p>
      </div>

      {schools.length > 0 && <div className="max-w-xl mb-5">
        <div className="label-eyebrow mb-1">titular da carteira</div>
        <Select value={scope} onValueChange={setScope}>
          <SelectTrigger className="rounded-none"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="personal">Minha conta pessoal</SelectItem>
            {schools.map((item) => <SelectItem key={item.id} value={item.id}>{item.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="md:col-span-2 border border-primary bg-primary text-primary-foreground p-7">
          <Coins size={28} weight="duotone" className="mb-6" />
          <div className="label-eyebrow opacity-80">saldo disponivel</div>
          <div className="font-display text-6xl font-black tracking-tighter mt-1">{loading ? "--" : account?.unlimited ? "Ilimitado" : account?.balance ?? 0}</div>
          <div className="text-xs font-mono-data mt-3 opacity-80">{account?.owner_name || "Conta pessoal"}</div>
        </div>
        <div className="border border-border bg-card p-6 flex flex-col justify-between">
          <ShieldCheck size={28} weight="duotone" className="text-primary" />
          <div><div className="font-display text-2xl font-bold">{account?.enforced ? "Ativa" : "Demonstracao"}</div><div className="text-xs text-muted-foreground mt-1">cobranca de creditos</div></div>
        </div>
      </div>

      <div className="border border-border bg-card">
        <div className="border-b border-border px-5 py-4 flex items-center gap-2"><Receipt size={20} className="text-primary" /><b className="font-mono-data">Extrato</b></div>
        <div className="divide-y divide-border">
          {!loading && entries.length === 0 && <div className="p-10 text-center label-eyebrow">nenhum lancamento</div>}
          {entries.map((entry) => <div key={entry.id} className="p-4 flex items-center justify-between gap-5 text-sm">
            <div><b>{entryLabel(entry.type)}</b><span className="block text-xs text-muted-foreground mt-1">{entry.description || new Date(entry.created_at).toLocaleString("pt-BR")}</span></div>
            <div className={`font-display text-2xl font-black ${Number(entry.amount) >= 0 ? "text-[hsl(var(--success))]" : "text-destructive"}`}>{Number(entry.amount) > 0 ? "+" : ""}{entry.amount}</div>
          </div>)}
        </div>
      </div>

      <p className="text-xs text-muted-foreground mt-5">A compra automatica sera conectada ao provedor de pagamentos por webhook. Enquanto isso, o administrador pode creditar saldos recebidos por contrato, transferencia ou cortesia.</p>
    </div>
  );
}
